export enum CompletionCommentType {
  User,
  System,
}